import { useState } from "react";
import { Newspaper, ExternalLink } from "lucide-react";

export const PulseCard = ({ items, userProfile, onItemClick }) => {
  if (!items || items.length === 0) {
    return (
      <section className="card-surface p-5 h-full" data-testid="pulse-card-empty">
        <h3 className="text-title-lg font-headline text-[#F8FAFC] mb-4">Today's Pulse</h3>
        <p className="text-[#94A3B8] text-sm">No pulse items available.</p>
      </section>
    );
  }

  return (
    <section className="card-surface p-5 h-full" data-testid="pulse-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Newspaper className="w-5 h-5 text-[#14B8A6]" />
          <h3 className="text-title-lg font-headline text-[#F8FAFC]">Today's Pulse</h3>
        </div>
        <span className="text-label-md text-[#14B8A6]">{items.length} updates</span>
      </div>

      <div className="space-y-2">
        {items.slice(0, 5).map((item, idx) => (
          <div
            key={item.id || idx}
            className="insight-border pl-4 py-3 hover:bg-white/[0.03] transition-all duration-200 rounded-r-lg cursor-pointer group"
            onClick={() => onItemClick && onItemClick(item)}
            data-testid={`pulse-item-${idx}`}
          >
            <div className="flex items-start justify-between gap-2">
              <h4 className="text-sm font-medium text-[#F8FAFC] line-clamp-2 mb-1 group-hover:text-[#14B8A6] transition-colors flex-1">
                {item.headline}
              </h4>
              {(item.source_url || item.metadata?.source?.url) && (
                <ExternalLink className="w-3.5 h-3.5 text-[#94A3B8]/40 group-hover:text-[#14B8A6] flex-shrink-0 mt-0.5" />
              )}
            </div>
            <p className="text-xs text-[#94A3B8] line-clamp-2">
              {item.summary || item.what_happened}
            </p>
            <div className="flex items-center gap-2 mt-2">
              {item.metadata?.content_origin === "real" && (
                <div className="flex items-center gap-1">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#14B8A6] animate-pulse" />
                  <span className="text-[10px] text-[#14B8A6]">Live</span>
                </div>
              )}
              {item.metadata?.source?.name && (
                <span className="text-[10px] text-[#94A3B8]">{item.metadata.source.name}</span>
              )}
            </div>
          </div>
        ))}
      </div>

      {items.length > 5 && (
        <button className="w-full mt-4 text-center text-sm text-[#14B8A6] font-medium hover:underline" data-testid="pulse-view-all">
          View all {items.length} updates
        </button>
      )}
    </section>
  );
};
